import { API, Card, CardStatus, Competition, Endpoints } from "@brg/api";
import { FC, ReactNode, useEffect, useMemo, useState } from "react";
import { FlexBox } from "@brg/ui";
import { DefaultButton } from "shared/pages/teams/styles";
import { useTranslation } from "react-i18next";

export enum CertificateType {
    'Winner' = 0,
    'AwardedFinalist' = 1,
    'Finalist' = 2,
    'Participant' = 3
}

export const CompetitionCertificatesBlock: FC<{ competition: Competition<'Global'> }> = ({
    competition
}) => {
    const {
        REACT_APP_GALLERY_LINK
    } = process.env;

    const { t } = useTranslation();

    const [certWinner, setCertWinner] = useState<Card<'Global'> | undefined>();
    const [certAwardedFinalist, setCertAwardedFinalist] = useState<Card<'Global'> | undefined>();
    const [certFinalist, setCertFinalist] = useState<Card<'Global'> | undefined>();
    const [certParticipant, setCertParticipant] = useState<Card<'Global'> | undefined>();

    const setCertificate = (competitionId: string, type: number): void => {
        API.request()
            .endpoint(Endpoints.cardsMnePw)
            .url('/api/Certificate')
            .get()
            .addQuery('competitionId', competitionId)
            .addQuery('certificateType', type.toString())
            .send()
            .then((b) => {
                if (b.status == 200) {
                    return b.json();
                }
            })
            .then((b: Card<'Global'> | undefined) => {
                if (type === CertificateType.Winner) {
                    setCertWinner(b);
                }
                else if (type === CertificateType.AwardedFinalist){
                    setCertAwardedFinalist(b);
                }
                else if (type === CertificateType.Finalist){
                    setCertFinalist(b);
                }
                else if (type === CertificateType.Participant) {
                    setCertParticipant(b);
                }
            });
    };

    useEffect(() => {
        if (!!competition && !!competition.competitionId) {
            setCertificate(competition.competitionId, CertificateType.Winner);
            setCertificate(competition.competitionId, CertificateType.AwardedFinalist);
            setCertificate(competition.competitionId, CertificateType.Finalist);
            setCertificate(competition.competitionId, CertificateType.Participant);
        }
    }, [competition]);

    var addCert = (competitionId: string, type: number): void => {
        const isConfirm = window.confirm("Подтверждаете действие?");

        if (isConfirm) {
            API.request()
                .endpoint(Endpoints.cardsMnePw)
                .url(`/api/Certificate/Add`)
                .post()
                .body({
                    competitionId: competitionId,
                    certificateType: type
                })
                .send()
                .then((d) => d.json())
                .then((d: Card<'Global'>) => {
                    setCertificate(competitionId, type);
                    window.open(`${REACT_APP_GALLERY_LINK}/card/${d.cardId}?shouldForcedLogin=true&saveLoginUrl=true`, '_blank');
                });
        }
    };

    var releaseCert = (competitionId: string, type: number): void => {
        const isConfirm = window.confirm("Подтверждаете действие?");

        if (isConfirm) {
            API.request()
                .endpoint(Endpoints.cardsMnePw)
                .url(`/api/Certificate/ReleaseCertificates`)
                .post()
                .body({
                    competitionId: competitionId,
                    certificateType: type
                })
                .send()
                .then(() => setCertificate(competitionId, type));
        }
    };

    var viewCert = (cardId: string, owners?: boolean): void => {
        window.open(`${REACT_APP_GALLERY_LINK}/card/${cardId}${owners ? "/owners" : ""}?shouldForcedLogin=true&saveLoginUrl=true`, '_blank');
    };

    const getButton = (competitionId: string, card: Card<'Global'> | undefined, type: number): ReactNode => {
        var typeText: string = "";

        switch (type) {
            case CertificateType.Winner:
                typeText = "winner";
                break;
            case CertificateType.AwardedFinalist:
                typeText = "shortlisted_participant";
                break;
            case CertificateType.Finalist:
                typeText = "finalist";
                break;
            case CertificateType.Participant:
                typeText = "participant";
                break;
            default:
                typeText = "";
                break;
        }

        const create = t(`competition_edit.certificates.${typeText}_create`);
        const view = t(`competition_edit.certificates.${typeText}_view`);
        const send = t(`competition_edit.certificates.${typeText}_send`);

        if (!card) {
            return <DefaultButton onClick={() => addCert(competitionId, type)} isCompetitionEdit hollow>{create}</DefaultButton>;
        }
        else if (card.statusCard === CardStatus.published) {
            if (card.additionalInfo.find(x => x.key === 'certificates_released')?.value === 'true') {
                return <DefaultButton onClick={() => viewCert(card.cardId, true)} isCompetitionEdit hollow>{view}</DefaultButton>;
            }

            return <DefaultButton onClick={() => releaseCert(competitionId, type)} isCompetitionEdit hollow>{send}</DefaultButton>;
        }
        else if (card.statusCard === CardStatus.awaitPayment) {
            return <DefaultButton onClick={() => viewCert(card.cardId)} isCompetitionEdit hollow>{t(`competition_edit.certificates.${typeText}_view_template`)}</DefaultButton>;
        }
        else {
            return <DefaultButton onClick={() => viewCert(card.cardId)} isCompetitionEdit hollow>{t(`competition_edit.certificates.${typeText}_view_template`)}</DefaultButton>;
        }
    }

    var winnerButton = useMemo(() => {
        return getButton(competition.competitionId, certWinner, CertificateType.Winner);
    }, [certWinner, t]);

    var awardedFinalistButton = useMemo(() => {
        return getButton(competition.competitionId, certAwardedFinalist, CertificateType.AwardedFinalist);
    }, [certAwardedFinalist, t]);

    var finalistButton = useMemo(() => {
        return getButton(competition.competitionId, certFinalist, CertificateType.Finalist);
    }, [certFinalist, t]);

    var participantButton = useMemo(() => {
        return getButton(competition.competitionId, certParticipant, CertificateType.Participant);
    }, [certParticipant, t]);

    return (
        <FlexBox direction="column" gy={10}>
            {winnerButton}
            {awardedFinalistButton}
            {finalistButton}
            {participantButton}
        </FlexBox>
    );
};import { API, Card, CardStatus, Competition, Endpoints } from "@brg/api";
import { FC, ReactNode, useEffect, useMemo, useState } from "react";
import { FlexBox } from "@brg/ui";
import { DefaultButton } from "shared/pages/teams/styles";
import { useTranslation } from "react-i18next";

export enum CertificateType {
    'Winner' = 0,
    'AwardedFinalist' = 1,
    'Finalist' = 2,
    'Participant' = 3
}

export const CompetitionCertificatesBlock: FC<{ competition: Competition<'Global'> }> = ({
    competition
}) => {
    const {
        REACT_APP_GALLERY_LINK
    } = process.env;

    const { t } = useTranslation();

    const [certWinner, setCertWinner] = useState<Card<'Global'> | undefined>();
    const [certAwardedFinalist, setCertAwardedFinalist] = useState<Card<'Global'> | undefined>();
    const [certFinalist, setCertFinalist] = useState<Card<'Global'> | undefined>();
    const [certParticipant, setCertParticipant] = useState<Card<'Global'> | undefined>();

    const setCertificate = (competitionId: string, type: number): void => {
        API.request()
            .endpoint(Endpoints.cardsMnePw)
            .url('/api/Certificate')
            .get()
            .addQuery('competitionId', competitionId)
            .addQuery('certificateType', type.toString())
            .send()
            .then((b) => {
                if (b.status == 200) {
                    return b.json();
                }
            })
            .then((b: Card<'Global'> | undefined) => {
                if (type === CertificateType.Winner) {
                    setCertWinner(b);
                }
                else if (type === CertificateType.AwardedFinalist){
                    setCertAwardedFinalist(b);
                }
                else if (type === CertificateType.Finalist){
                    setCertFinalist(b);
                }
                else if (type === CertificateType.Participant) {
                    setCertParticipant(b);
                }
            });
    };

    useEffect(() => {
        if (!!competition && !!competition.competitionId) {
            setCertificate(competition.competitionId, CertificateType.Winner);
            setCertificate(competition.competitionId, CertificateType.AwardedFinalist);
            setCertificate(competition.competitionId, CertificateType.Finalist);
            setCertificate(competition.competitionId, CertificateType.Participant);
        }
    }, [competition]);

    var addCert = (competitionId: string, type: number): void => {
        const isConfirm = window.confirm("Подтверждаете действие?");

        if (isConfirm) {
            API.request()
                .endpoint(Endpoints.cardsMnePw)
                .url(`/api/Certificate/Add`)
                .post()
                .body({
                    competitionId: competitionId,
                    certificateType: type
                })
                .send()
                .then((d) => d.json())
                .then((d: Card<'Global'>) => {
                    setCertificate(competitionId, type);
                    window.open(`${REACT_APP_GALLERY_LINK}/card/${d.cardId}?shouldForcedLogin=true&saveLoginUrl=true`, '_blank');
                });
        }
    };

    var releaseCert = (competitionId: string, type: number): void => {
        const isConfirm = window.confirm("Подтверждаете действие?");

        if (isConfirm) {
            API.request()
                .endpoint(Endpoints.cardsMnePw)
                .url(`/api/Certificate/ReleaseCertificates`)
                .post()
                .body({
                    competitionId: competitionId,
                    certificateType: type
                })
                .send()
                .then(() => setCertificate(competitionId, type));
        }
    };

    var viewCert = (cardId: string, owners?: boolean): void => {
        window.open(`${REACT_APP_GALLERY_LINK}/card/${cardId}${owners ? "/owners" : ""}?shouldForcedLogin=true&saveLoginUrl=true`, '_blank');
    };

    const getButton = (competitionId: string, card: Card<'Global'> | undefined, type: number): ReactNode => {
        var typeText: string = "";

        switch (type) {
            case CertificateType.Winner:
                typeText = "winner";
                break;
            case CertificateType.AwardedFinalist:
                typeText = "shortlisted_participant";
                break;
            case CertificateType.Finalist:
                typeText = "finalist";
                break;
            case CertificateType.Participant:
                typeText = "participant";
                break;
            default:
                typeText = "";
                break;
        }

        const create = t(`competition_edit.certificates.${typeText}_create`);
        const view = t(`competition_edit.certificates.${typeText}_view`);
        const send = t(`competition_edit.certificates.${typeText}_send`);

        if (!card) {
            return <DefaultButton onClick={() => addCert(competitionId, type)} isCompetitionEdit hollow>{create}</DefaultButton>;
        }
        else if (card.statusCard === CardStatus.published) {
            if (card.additionalInfo.find(x => x.key === 'certificates_released')?.value === 'true') {
                return <DefaultButton onClick={() => viewCert(card.cardId, true)} isCompetitionEdit hollow>{view}</DefaultButton>;
            }

            return <DefaultButton onClick={() => releaseCert(competitionId, type)} isCompetitionEdit hollow>{send}</DefaultButton>;
        }
        else if (card.statusCard === CardStatus.awaitPayment) {
            return <DefaultButton onClick={() => viewCert(card.cardId)} isCompetitionEdit hollow>{t(`competition_edit.certificates.${typeText}_view_template`)}</DefaultButton>;
        }
        else {
            return <DefaultButton onClick={() => viewCert(card.cardId)} isCompetitionEdit hollow>{t(`competition_edit.certificates.${typeText}_view_template`)}</DefaultButton>;
        }
    }

    var winnerButton = useMemo(() => {
        return getButton(competition.competitionId, certWinner, CertificateType.Winner);
    }, [certWinner, t]);

    var awardedFinalistButton = useMemo(() => {
        return getButton(competition.competitionId, certAwardedFinalist, CertificateType.AwardedFinalist);
    }, [certAwardedFinalist, t]);

    var finalistButton = useMemo(() => {
        return getButton(competition.competitionId, certFinalist, CertificateType.Finalist);
    }, [certFinalist, t]);

    var participantButton = useMemo(() => {
        return getButton(competition.competitionId, certParticipant, CertificateType.Participant);
    }, [certParticipant, t]);

    return (
        <FlexBox direction="column" gy={10}>
            {winnerButton}
            {awardedFinalistButton}
            {finalistButton}
            {participantButton}
        </FlexBox>
    );
};